/* eslint-disable sort-keys-fix/sort-keys-fix */
import { COMMUNITY_PAGES_PATH_PREFIX, type CommunityData } from "./types"

const shelter: CommunityData = {
  code: "shelter",
  inviteCode: "shelter",
  name: "Shelter",
  thumbnail: "",
  favicon: "",
  url: `${COMMUNITY_PAGES_PATH_PREFIX}/shelter`,
  socials: {},
  styles: {
    global: {
      counterColor: "#FFFFFF",
      logo: {
        src: "/assets/customizations/shelter/logo-1.png",
        styles: "w-[122px]",
      },
      alternativeLogo: {
        src: "/assets/customizations/shelter/logo-2.png",
        styles: "w-[122px]",
      },
      modalWindow: {
        container: "",
        title: "",
        subtitle: "",
      },
      contentBoxShadow: "border-[1px] border-[#FFFFFF]",
      bgColor: "#FEAD0C",
      asideBg: "#2E2E2E",
      asideStyles: "border-r-[#FFFFFF] border-r",
      contentBg: "#2E2E2E",
      bgDesktop: "/assets/customizations/shelter/bg.png",
      bgMobile: "/assets/customizations/shelter/bg.png",
      mainFont: "font-['HaasGrotesk']",
      primaryButton:
        "flex justify-center items-center !text-[20px] pt-1 !h-[56px] bg-[#2E2E2E] border border-[1px] border-[#FFFFFF] !text-[#FFFFFF] sm:!min-w-[186px] min-w-[160px] text-nowrap cursor-pointer",
    },
    navigation: {
      sideBarSeparator: "",
      iconsColor: "#FFFFFF",
      separator: "border-t-[#FFFFFF] border-t",
      item: "text-[20px] text-[#FFFFFF] h-[40px] flex sm:justify-start justify-center items-center sm:!pt-1 !pt-5",
      itemSelected: "custom-prefix",
    },
    communityLanding: {
      titles: "text-[28px] text-[#FFFFFF] leading-[48px]",
      announcements: {
        lg: {
          title:
            "!text-[10px] pt-[2px] font-['Arial'] px-[6px] bg-[#2E2E2E] w-fit !text-[#FFFFFF] h-[19px] flex items-center",
          subtitle:
            "!text-[10px] font-['Arial'] px-[6px] bg-[#2E2E2E] w-fit !text-[#FFFFFF] h-[19px] flex items-center",
        },
        sm: {
          title:
            "!text-[10px] pt-[2px] font-['Arial'] px-[6px] bg-[#2E2E2E] !w-fit !text-[#FFFFFF] h-[19px] flex items-center",
          subtitle:
            "!text-[10px] font-['Arial'] px-[6px] bg-[#2E2E2E] !w-fit !text-[#FFFFFF] h-[19px] flex items-center",
        },
      },
      event: {
        title: "text-[20px] text-[#FFFFFF] one-line-truncate",
        subtitle: "text-[#FFFFFF] text-[14px] font-['Arial']",
      },
      shop: {
        title: "text-[20px] text-[#FFFFFF]",
        text: "text-[#FFFFFF] text-[14px] leading-[18px] font-['Arial']",
        customShopImage: "/assets/customizations/shelter/shop.png",
      },
      emptyOrLoadingState: "text-[#FFFFFF] text-[14px]",
    },
    announcements: {
      created: "text-[#FFFFFF] text-[14px] leading-[18px] font-['Arial']",
      emptyOrLoadingState: "text-[#FFFFFF] text-[14px]",
      container: "mb-16 sm:p-11 p-7 sm:space-y-[38px] space-y-[33px]",
      header: "text-[28px] text-[#FFFFFF]",
      title: "text-[20px] text-[#FFFFFF]",
      description: "text-[#FFFFFF] text-[14px] leading-[18px] font-['Arial']",
    },
    announcement: {
      likeCount: "text-[#FFFFFF]",
      commentCount: "text-[#FFFFFF]",
      created: "text-[#FFFFFF] text-[14px] leading-[18px] font-['Arial']",
      emptyOrLoadingState: "text-[#FFFFFF] text-[14px]",
      container: "sm:p-10 p-7 pb-8 space-y-[23px]",
      title: "text-[20px] text-[#FFFFFF]",
      description: "text-[#FFFFFF] text-[14px] leading-[18px] font-['Arial']",
      commentIconColor: "#FFFFFF",
      likeIconColor: "#FFFFFF",
    },
    events: {
      sectionHeader: "text-[20px] text-[#FFFFFF]",
      container: "mb-16 sm:p-11 p-7 sm:pb-8 sm:space-y-[57px] space-y-[25px]",
      header: "text-[28px] text-[#FFFFFF]",
      title: "text-[20px] text-[#FFFFFF]",
      emptyOrLoadingState: "text-[#FFFFFF] text-[14px]",
      duration: "mb-4 text-[#FFFFFF] text-[14px] leading-[18px] font-['Arial']",
      address: "text-[#FFFFFF] text-[14px] leading-[18px] font-['Arial']",
      separator: "mb-8 mt-2 border-b border-b-[1px] border-[#FFFFFF]",
    },
    event: {
      blockContainer: "flex flex-col gap-3",
      container: "flex flex-col sm:p-11 p-6",
      emptyOrLoadingState: "text-[#FFFFFF] text-[14px]",
      header: "text-[28px] text-[#FFFFFF] !mt-0 sm:mb-0 mb-[24px]",
      sectionTitle: "text-[20px] text-[#FFFFFF]",
      sectionSubtitle: "text-[#FFFFFF] text-[14px] leading-[18px] font-['Arial']",
      text: "text-[#FFFFFF] text-[14px] leading-[18px] font-['Arial']",
      separator: "sm:my-8 my-6 border-b border-b-[1px] border-[#FFFFFF]",
      map: {
        pin: "",
        border: "mb-2 border-[1px] border-[#FFFFFF] overflow-hidden",
        pinColor: "#FFFFFF",
        strokeColor: "#FFFFFF",
      },
    },
    eventTickets: {
      container: "flex flex-col sm:p-11 p-6",
      event: {
        title: "text-[28px] text-[#FFFFFF] !mt-0",
        subtitle: "text-[#FFFFFF] text-[14px] leading-[18px] font-['Arial']",
      },
      ticket: {
        title: "text-[20px] text-[#FFFFFF]",
        description: "text-[#FFFFFF] text-[14px] leading-[18px] font-['Arial']",
        text: "text-[#FFFFFF] text-[10px] leading-[18px] font-['Arial']",
        price: "text-[20px] text-[#FFFFFF]",
        counterContainer: "text-[20px] text-[#FFFFFF] !border-[#FFFFFF]",
        quantity: "text-[20px] text-[#FFFFFF] !border-[#FFFFFF]",
      },
      separator: "sm:my-8 my-6 border-b-[#FFFFFF] border-b-[1px]",
    },
    shop: {},
  },
}

export default shelter
